import React from 'react';
import { capitalize } from 'store/utility';
import styles from './QRLabelRow.module.css';

const formatKey = key => {
  if (key !== undefined) {
    if (key === 'remark') return 'Remark(s)';
    else if (key === 'qrcode_price') return 'Price';
    else if (key === 'title') return 'Item';
    else if (key === 'country') return 'Origin';
    else if (key === 'dimensions') return 'Size';
    else return capitalize(key);
  }
};

const formatValue = (key, value, settings) => {
  if (key === 'dimensions') {
    return value.map((e, i) => (
      <span className={styles.Dimension} key={i}>
        {e}
      </span>
    ));
  } else if (key === 'title') {
    return (
      <span>
        <strong>{value}</strong>
      </span>
    );
  } else if (key === 'qrcode_price') {
    var unit = value[value.length - 1];

    if (value.length === 3) {
      var price = value[0];
      var priceGST = value[1];
      return (
        <div>
          <span className={styles.Price}>
            <span>{price}</span>
            <span>{unit}</span>
          </span>

          <span className={styles.Price}>
            <span>{priceGST}</span>
            <span>
              {unit} (incl. {settings ? settings.gst : ''}% GST)
            </span>
          </span>
        </div>
      );
    } else {
      var priceOld = value[0];
      var priceSale = value[1];
      var priceSaleGST = value[2];
      return (
        <div>
          <span className={styles.Price}>
            <span className={styles.PriceOld}>{priceOld}</span>
            <span className={styles.PriceNew}>{priceSale}</span>
            <span>{unit}</span>
          </span>
          <span className={styles.Price}>
            <span className={styles.PriceNew}>{priceSaleGST}</span>
            <span>
              {unit} (incl. {settings ? settings.gst : ''}% GST)
            </span>
          </span>
        </div>
      );
    }
  } else if (key === 'remark') {
    return value.split('\n').map((v, i) => (
      <span className={styles.Remark} key={i}>
        {v}
      </span>
    ));
  }
  return <span>{value}</span>;
};

const QRLabelRow = props => {
  const { label, value, settings } = props;
  const styleClass = label === 'qrcode_price' ? styles.QRCodePrice : styles.Label;
  const styleValue = label === 'remark' ? `${styles.Value} ${styles.QRCodeRemark}` : styles.Value;

  return (
    <div className={styles.Row}>
      <div className={styleClass}>
        <span>{formatKey(label)}</span>
        <span>:</span>
      </div>
      <div className={styleValue}>{formatValue(label, value, settings)}</div>
    </div>
  );
};

export default QRLabelRow;



// WEBPACK FOOTER //
// ./src/components/QRcode/QRLabelRow.js